export enum ActiveLogisticsPlan {    
    Primary = 1,
    Backup = 2
}